import React, { useState, useEffect } from "react";
import "./SendResumeJob.css";
import JobSearch from "../../../Assets/img/jobSearch.png";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Loader from "react-loader-spinner";

function SendResumeJob() {
  const { id } = useParams();
  const [posts, setPosts] = useState([]);
  const [loader, setLoader] = useState(true);
  const [text, setText] = useState(false);

  useEffect(() => {
    if (!id) {
      setLoader(false);
      setText(true);
      return;
    }

    const token = localStorage.getItem("token");

    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/resume-submitted-jobOpportunity/${id}`,
        {
          headers: token
            ? {
                Authorization: `Bearer ${token}`,
              }
            : {},
        }
      )
      .then((res) => {
        console.log("Response:", res.data);

        // پشتیبانی از ساختارهای مختلف پاسخ
        let data = [];
        if (Array.isArray(res.data)) {
          data = res.data;
        } else if (res.data?.data && Array.isArray(res.data.data)) {
          data = res.data.data;
        } else if (res.data && typeof res.data === "object") {
          data = [res.data];
        }

        if (!data || data.length === 0) {
          setText(true);
          setPosts([]);
        } else {
          setPosts(data);
          setText(false);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.error("Error:", err.response?.data || err.message);
        setLoader(false);
        setText(true);
      });
  }, [id]);

  // استخراج اطلاعات شغل از ساختارهای مختلف
  const getJobInfo = (post) => {
    if (post.submitted?.[0]) return post.submitted[0];
    if (post.submitted && !Array.isArray(post.submitted)) return post.submitted;
    if (post.jobOpportunity?.[0]) return post.jobOpportunity[0];
    if (post.jobOpportunity) return post.jobOpportunity;
    if (post.job?.[0]) return post.job[0];
    if (post.job) return post.job;
    if (post.title || post.country) return post;
    return {};
  };

  return (
    <div className="send-resume-job">
      <Header title="درخواست های من" />
      <div className="job-list">
        <div className="job-list-body-r">
          {loader ? (
            <div className="spinner">
              <Loader
                type="TailSpin"
                color="rgb(236, 177, 28)"
                height={80}
                width={80}
              />
            </div>
          ) : text || posts.length === 0 ? (
            <p className="font">درخواستی وجود ندارد</p>
          ) : (
            posts.map((post, index) => {
              const job = getJobInfo(post);
              const linkId = job?.id || job?._id || post._id || index;

              return (
                <Link
                  to={`/single-job/${linkId}`}
                  key={post._id || linkId || index}
                >
                  <div className="job-list-title-r">
                    <div className="job-list-text-time">
                      <h6>{job?.country || "—"}</h6>
                    </div>
                    <h5>{job?.title || "بدون عنوان"}</h5>
                    <p className="two-line">
                      {job?.responsibility || job?.description || ""}
                    </p>
                  </div>

                  <div className="job-list-title-icon">
                    <img src={JobSearch} alt="JobSearch" />
                  </div>
                </Link>
              );
            })
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SendResumeJob;